<script lang="ts">import { isMobile } from "@infinitro/global";
import { GradientBorder } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
export let title;
export let image;
</script>

<div class="vip-reward-card-container">
	<GradientBorder
		radius={$isMobile ? 6 : 16}
		padding={1}
		gradient="linear-gradient(180deg, var(--color-primary-500) 0%, rgba(255,255,255,0) 100%)"
	>
		{#key $isMobile}
			<div class="vip-reward-card-content">
				<Text
					type="subtitle"
					subtitleSize={$isMobile ? 'small' : 'large'}
					textAlign="center"
					customStyle="font-size: {$isMobile ? '12px' : ''};">{title}</Text
				>
				<img src={image} alt={title} class="vip-reward-card-image" />
			</div>
		{/key}
	</GradientBorder>
</div>

<style>
	.vip-reward-card-container {
		width: 48%;
		max-width: 150px;
		justify-self: center;
		aspect-ratio: 232 / 278;
}

	.vip-reward-card-content {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		overflow: hidden;
		border-radius: 6px;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		background: linear-gradient(
			180deg,
			var(--color-background-500) 6.9%,
			var(--color-background-700) 86.07%
		);

		z-index: 1;
}

	.vip-reward-card-content::after {
		content: '';
		position: absolute;
		top: -20%;
		left: -20%;
		width: 140%;
		height: 100%;
		background: radial-gradient(ellipse at center, var(--color-primary-500) 0%, transparent 100%);
		filter: blur(20px);
		mix-blend-mode: saturation;
		pointer-events: none;
		z-index: 0;
	}

	.vip-reward-card-content::before {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: inherit;
		pointer-events: none;
		box-shadow:
			0 0 4.394px 0 var(--color-primary-500) inset,
			0 0 12px 0 var(--color-primary-500) inset;
		z-index: 2;
	}

	.vip-reward-card-image {
		height: auto;
		width: 100%;
		--tw-translate-y: -5px;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		-o-object-fit: contain;
		   object-fit: contain;
		position: relative;
		z-index: 1;
}

	@media (min-width: 1024px) {
		.vip-reward-card-container {
				width: 24%;
				max-width: 232px;
			aspect-ratio: 232 / 278;
		}

		.vip-reward-card-content {
				border-radius: 16px;
				padding-top: 1rem;
				padding-bottom: 1rem;
		}
	}
</style>
